export class StatisticsService {
  constructor () {
    'ngInject';
  }

  getStatsWeight(data) {
    const aggregate = {
      aggregateVirgin: data.filter( x => !x.casemanStatus && !x.syncStatus).map(x => x.minutes),
      aggregateFailed: data.filter( x => x.syncStatus || (x.casemanStatus && x.casemanStatus != "Success")).map(x => x.minutes),
      aggregateSuccessful: data.filter( x => x.casemanStatus == "Success").map(x => x.minutes)
    };

    const sum = aggregate.aggregateVirgin.reduce( (a,b) => a+b, 0) + aggregate.aggregateFailed.reduce( (a,b) => a+b, 0) + aggregate.aggregateSuccessful.reduce( (a,b) => a+b, 0);

    let width = {
      virgin: 100,
      failed: 0,
      successful: 0
    };

    if(sum){
      width = {
        virgin: Math.round((aggregate.aggregateVirgin.reduce( (a,b) => a+b, 0) * 100 / sum) * 100) /100 ,
        failed: Math.round((aggregate.aggregateFailed.reduce( (a,b) => a+b, 0) * 100 / sum)  * 100) /100,
        successful: Math.round((aggregate.aggregateSuccessful.reduce( (a,b) => a+b, 0) * 100 / sum)  * 100) /100
      };
    }

    return width;
  }
}